import { Injectable } from '@angular/core';
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';
import { HttpParams } from '@angular/common/http';
import { GruaMotiusDesestimarFilter } from '../models/grua-motius-desestimar-filter';

const defaultSortParam = 'motiu';
const defaultSortDirection = 'asc';

@Injectable()
export class GruaMotiusDesestimarFilterService extends CustomFilterService {
  public createFilterParams(filter: GruaMotiusDesestimarFilter, start: number, pageSize: number, sortField: string, sortDir: string ) {

    return new HttpParams()
    .append('SHOW_PDA', this.getTristateValue(filter.SHOW_PDA))
    .append('motiu', filter.motiu)
    .append('start', start.toString())
    .append('size', pageSize.toString())
    .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
    .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir);
  }
}
